import "../tutorialPage/TutorialPage.less";
import React, { RefObject } from "react";
import { EPage } from "../../Main";
import TutorialPage from "../tutorialPage/TutorialPage";
import { EBackgroundColor } from "../../components/gridBackground/GridBackground";
import Anims from "../../data/Anims";

interface IProps {}

class TutorialPage1 extends TutorialPage {
  // --------------------------------------------------------------------------- INIT
  constructor(pProps: IProps, pContext: any) {
    super(pProps, pContext);

    this.initState({
      currentSlideIndex: 0,
      nextPage: EPage.TutorialPage2,
      background: EBackgroundColor.GOLD,
      nextBackground: EBackgroundColor.GOLD_LIGHT,
      anim: Anims.tuto1,
      isBackgroundVisible: true
    });

    this.initAnim();
  }

  // --------------------------------------------------------------------------- TRANSITION

  // --------------------------------------------------------------------------- RENDER
}

export default TutorialPage1;
